import React, { Component } from "react";
import axios from "axios";
import ReactTooltip from "react-tooltip";
import compareValues from "./SortValue.js";
import CryptoJS from "crypto-js";
import config from "../../config/authConfig.js";
function CustomCompMRC(props) {
  return (
    <div>
      <span className="toolTipHeader">Payroll MRC :</span>
      <ul>
        {props.dataTip != null &&
          props.dataTip.split(";").map((it) => {
            return <li>{it}</li>;
          })}
      </ul>
    </div>
  );
}
class LegalEntities extends Component {
  constructor(props) {
    super(props);
    this.state = {
      LEItemData: [],
      lecode: "",
      leName: "",
      isMandatory: false,
      selectedvalue: "",
      isLoaded: false,
      sessionID: "",
    };
  }
  async componentDidMount() {
    var lsWWID_dec = "1461636";
    if (process.env.REACT_APP_WORKDAY_LOCAL_DEBUG != "Yes") {
      //   const secretKeyforEncryption = config.encryptionkey;
      //   const aliasWWIDName = config.aliasWWIDName;
      //   var lsWWID = sessionStorage.getItem(aliasWWIDName);
      //   var lsWWID_dec_bytes = CryptoJS.AES.decrypt(lsWWID, secretKeyforEncryption);
      //   lsWWID_dec = JSON.parse(lsWWID_dec_bytes.toString(CryptoJS.enc.Utf8));

      const secretKeyforEncryption = config.encryptionkey;
      var lsWWID = localStorage.getItem("wwid");
      var lsWWID_dec_bytes = CryptoJS.AES.decrypt(
        lsWWID,
        secretKeyforEncryption
      );
      var lsWWID_dec = JSON.parse(lsWWID_dec_bytes.toString(CryptoJS.enc.Utf8)); //this will decrypt the encrypted value.
      //   console.log({ lsWWID_dec });
    }
    window.addEventListener("resize", this.SetWidth);
    if (this.props.lecode != "") {
      this.setState({
        lecode: this.props.lecode,
        leName: this.props.leName,
        selectedvalue: this.props.lecode,
      });
    }
    if (this.props.mngwwid != "" && this.props.locationreferenceID != "") {
      await axios({
        method: "POST",
        url: process.env.REACT_APP_WORKDAY_API_URL + "getLEAndPayrollMRC ",
        headers: {
          apiKey: process.env.REACT_APP_WORKDAY_API_KEY,
          clientKey: process.env.REACT_APP_WORKDAY_API_CLIENTKEY,
          "Content-Type": "application/json",
        },
        data: {
          managerWWID: this.props.mngwwid,
          locationCode: this.props.locationreferenceID,
          sessionID: this.props.sessionID,
          //   loggedInUserWWID: "1461636",
          loggedInUserWWID: lsWWID_dec,
        },
      })
        .then((res) => {
          this.setState({
            LEItemData: res.data.legalEntityList,
            sessionID: res.data.sessionId,
            isLoaded: true,
          });
        })
        .catch((error) => {
          //on error
          //  alert("There is an error in API call mngid.");
        });
      if (this.state.LEItemData.length > 0) {
      } else {
        this.props.isLePresent(this.state.sessionID);
      }
    } else {
    }
    this.SetWidth();
  }
  SetWidth = () => {
    var header = document.querySelectorAll(".accordionheader");
    for (var i = 0; i < header.length; i++) {
      header[i].style.width =
        this.DimensionWidth(header[i].parentElement) -
        this.DimensionWidth(header[i].previousSibling) -
        this.DimensionWidth(header[i].nextSibling) -
        20 +
        "px";
    }
  };
  DimensionWidth = (elmID) => {
    var elmHeight,
      elmMargin,
      elm = elmID;
    if (document.all) {
      // IE
      elmHeight = elm.offsetWidth;
      elmMargin =
        parseInt(elm.currentStyle.marginLeft, 10) +
        parseInt(elm.currentStyle.marginRight, 10);
    } else {
      // Mozilla
      elmHeight = elm.offsetWidth;
      elmMargin =
        parseInt(
          document.defaultView
            .getComputedStyle(elm, "")
            .getPropertyValue("margin-left")
        ) +
        parseInt(
          document.defaultView
            .getComputedStyle(elm, "")
            .getPropertyValue("margin-right")
        );
    }
    return elmHeight + elmMargin;
  };
  legaldata = (legalitemdata) => {
    if (legalitemdata.length > 0) {
      return legalitemdata.map((item, index) => {
        let dataTipvalue = "";
        if (item.payrollMRCList.length > 0) {
          let payrollMRCListArr = item.payrollMRCList.sort(
            compareValues("payrollMRCCode")
          );
          for (let i = 0; i < payrollMRCListArr.length; i++) {
            if (i != 0) {
              dataTipvalue += ";";
            }
            dataTipvalue +=
              payrollMRCListArr[i].payrollMRCCode +
              " - " +
              payrollMRCListArr[i].payrollMRCName;
          }
        } else {
          dataTipvalue += ";";
        }

        return (
          <li
            key={item.legalEntity.leCode}
            value={item.legalEntity.leCode}
            className={
              this.state.selectedvalue == item.legalEntity.leCode
                ? "lilist select-search-box__row lelist changebgcolor"
                : "lilist select-search-box__row lelist"
            }
            onClick={(e) => {
              this.handleCheck(
                item.legalEntity.leCode,
                item.legalEntity.leName
              );
            }}
          >
            <span className="leradiospan">
              <input
                type="radio"
                id={item.legalEntity.leCode}
                checked={this.state.lecode === item.legalEntity.leCode}
                name="radio"
                onChange={(e) => {
                  this.handleCheck(
                    item.legalEntity.leCode,
                    item.legalEntity.leName
                  );
                }}
              ></input>
            </span>
            <span className="accordionheader" title={item.legalEntity.leName}>
              {item.legalEntity.leCode} - {item.legalEntity.leName}
            </span>

            <span
              className="hoverlelist"
              style={{ float: "right" }}
              data-for="enrich"
              data-tip={dataTipvalue}
            >
              {item.payrollMRCList.length} Associated MRC
              <ReactTooltip
                key={index}
                effect="solid"
                className="customeTheme extraClass"
                id="enrich"
                getContent={(dataTip) => <CustomCompMRC dataTip={dataTip} />}
              />
            </span>
          </li>
        );
      });
    }
  };

  handleCheck = (id, val) => {
    this.setState({ lecode: id, leName: val, selectedvalue: id });
  };

  handleLEData = () => {
    if (this.state.lecode != "") {
      this.props.onclickLENext(
        this.state.lecode,
        this.state.leName,
        this.state.sessionID
      );
      this.setState({ isMandatory: false });
    } else {
      this.setState({ isMandatory: true });
    }
  };
  handleLEDataBack = () => {
    this.props.onclickLEBack();
  };

  render() {
    return (
      <div>
        {this.state.isLoaded ? (
          <div>
            <h4 className="listheader">
              Please select a recommended{" "}
              <span className="listheadertext">Legal Entity (LE):</span>
            </h4>
            <ul className="ulist">
              {this.legaldata(this.state.LEItemData)}
              <li
                className={
                  this.state.selectedvalue == "noa"
                    ? "lenoneoftheabove changebgcolor"
                    : "lenoneoftheabove"
                }
                onClick={(e) => {
                  this.handleCheck("noa", "noa");
                }}
              >
                <span className="leradiospan">
                  <input
                    type="radio"
                    id="noa"
                    name="radio"
                    value="noa"
                    checked={this.state.lecode === "noa"}
                    onChange={(e) => {
                      this.handleCheck("noa", "noa");
                    }}
                  ></input>
                </span>
                <span className="letext" title="None of the above">
                  None of the above
                </span>
              </li>
            </ul>
          </div>
        ) : (
          <div className="dataLoader">Loading data please wait...</div>
        )}
        {this.state.isMandatory === true ? (
          <label className="MandatoryFields">
            Please select a recommended Legal Entity (LE)
          </label>
        ) : (
          ""
        )}
        {this.state.isLoaded ? (
          <div className="last-column rowhead lebtn">
            <div className="nextbtn leback">
              {" "}
              <input
                type="submit"
                value="< Back"
                className="btncls"
                onClick={this.handleLEDataBack}
              />
            </div>
            <div className="nextbtn lenext">
              {" "}
              <input
                type="submit"
                value="Next >"
                onClick={this.handleLEData}
                className="btncls"
              />
            </div>
          </div>
        ) : (
          ""
        )}
      </div>
    );
  }
}
export default LegalEntities;
